import { useDossierContext } from './SuiviPrivatisationLayout';
import { PIPELINE_STAGE_LABELS, PipelineStage } from './pipelineStages';

const fmtJour = (d?: string | null) => {
    if (!d) return '—';
    try { return new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }).replace('.', ''); } catch { return '—'; }
};
const fmtHeure = (d?: string | null) => {
    if (!d) return '';
    try { return new Date(d).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }); } catch { return ''; }
};

const libelle = (s?: string | null) => (s ? PIPELINE_STAGE_LABELS[s as PipelineStage] || s : '');

/**
 * Onglet « Historique » — chaque mouvement du dossier, dans l'ordre où il s'est produit.
 *
 * Ce journal est volontairement tenu à l'écart de la suppression en cascade : supprimer une privatisation
 * emporte ses documents, mais laisse cette trace. « On ne garde pas les PDF, on garde juste l'historique
 * de la demande » — Emeni, 2026-08-26.
 */
export function DossierJournalPage() {
    const { dossier } = useDossierContext();

    if (dossier.journal.length === 0) {
        return <p className="text-[12px] text-content-muted">Aucun mouvement enregistré.</p>;
    }

    return (
        <div className="flex flex-col">
            {dossier.journal.map((j, i) => (
                <div key={i} className={`flex gap-[11px] py-[9px] ${i > 0 ? 'border-t border-border-soft' : ''}`}>
                    <span className="font-mono text-[10.5px] text-content-muted tabular-nums w-12 shrink-0 leading-[1.45] whitespace-nowrap" title={fmtHeure(j.changed_at)}>{fmtJour(j.changed_at)}</span>
                    <div className="min-w-0">
                        <p className="text-[12px] leading-[1.45] text-content text-pretty">
                            {/* Tout n'est pas un changement d'étape : le dépôt du devis signé par le
                                client est un événement du dossier, qui ne le fait pas avancer. Écrire
                                « Devis envoyé → Devis envoyé » n'aurait dit à personne ce qui s'est passé. */}
                            {!j.from_stage
                                ? <span className="font-bold">Ouverture du dossier</span>
                                : j.from_stage === j.to_stage
                                    ? <span className="font-bold">{libelle(j.to_stage)}</span>
                                    : <>{libelle(j.from_stage)} &rarr; <span className="font-bold">{libelle(j.to_stage)}</span></>}
                        </p>
                        <p className="mt-px text-[10.5px] text-content-muted">
                            {j.actor_label}{j.note ? ` \u2014 ${j.note}` : ''}{fmtHeure(j.changed_at) ? ` · ${fmtHeure(j.changed_at)}` : ''}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
}
